import React from "react"
import { CgSpinnerTwo } from "react-icons/cg"
import { tw } from "twind"

export const Spinner = () => (
  <>
    <CgSpinnerTwo className={tw(`mx-auto my-20`, ` h-20 w-20`, `text-blue-900`, `animate-spin`)} />
  </>
)
